import { render, staticRenderFns } from "./PromotionsBadge.vue?vue&type=template&id=1b5901f4&scoped=true"
import script from "./PromotionsBadge.vue?vue&type=script&lang=js"
export * from "./PromotionsBadge.vue?vue&type=script&lang=js"
import style0 from "./PromotionsBadge.vue?vue&type=style&index=0&id=1b5901f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5901f4",
  null
  
)

export default component.exports